export enum EnquiryType {
    NotSet = 0,
    Quotation = 1,
    TestDrive = 2,
    Brochure = 4,
    BasicEnquiry = 8,
    UsedVehicle = 64,
}
